export default __webpack_public_path__ + "static/media/correspondent22.b3437c7d.png";